// User-selectable default landing page (iMove A1).
// Persisted in localStorage for now; can move to a backend per-provider setting later.

import { checkIfAdmin, checkIfOwner } from '@guryou/utils';

const KEY = 'gy-deal-landing-page';

export const DEFAULT_LANDING_PAGE = 'calendar';

// Pages a provider can pick as their default landing page (marked via the header pin).
export const LANDING_OPTIONS = [
  { value: 'calendar', label: 'Calendar' },
  { value: 'dashboard', label: 'Dashboard' },
  { value: 'customers', label: 'Customers' },
  { value: 'chat', label: 'Chat' },
];

export const LANDING_ELIGIBLE = LANDING_OPTIONS.map(o => o.value);

export const getLandingPage = () => {
  try {
    return localStorage.getItem(KEY) || DEFAULT_LANDING_PAGE;
  } catch (e) {
    return DEFAULT_LANDING_PAGE;
  }
};

export const setLandingPage = page => {
  try {
    localStorage.setItem(KEY, page);
  } catch (e) {
    // localStorage unavailable — ignore, fall back to default
  }
};

// Where to land at the management (multi-provider) level: owners/admins get the
// management dashboard; everyone else the providers list (the rankings query is
// owner/admin only, and most other roles drop straight into a single provider).
export const getManagementLandingPath = () => (checkIfOwner() || checkIfAdmin() ? '/management/dashboard' : '/management/providers');
